import "./SeedFooter.css";

import { KanaSeedLogoBlue, PoweredByKanaLogo } from "../../../assets";

export const SeedFooter = (): JSX.Element => {
  return (
    <div className="SeedFooter">
      <KanaSeedLogoBlue />
      <PoweredByKanaLogo />
    </div>
  );
};
